import { render } from "./purchasedcoursespage.vue?vue&type=template&id=2c05be4d&scoped=true"
import script from "./purchasedcoursespage.vue?vue&type=script&lang=js"
export * from "./purchasedcoursespage.vue?vue&type=script&lang=js"

import "./purchasedcoursespage.vue?vue&type=style&index=0&id=2c05be4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c05be4d"]])

export default __exports__